module.exports = __webpack_public_path__ + "img/title.0315c03a.png";